<pmt-action-modal [title]="'assignments.participants.skills.modalTitle'| transloco"
    [submitButtonText]="isConfirming ? confirmTextKey : nextTextKey" cancelButtonText="modal.cancelButton"
    submitButtonIconCode="" (submitted)="next()" class="custom-modal-limiter" [isSaving]="isLoading">
    <ng-container *ngIf="!participantsSkills">
        <div class="text-center">
            <i class="fa-solid fa-spinner fa-spin"></i>
        </div>
    </ng-container>

    <ng-container *ngIf="participantsSkills && !isConfirming">
        <div class="table-responsive" style="max-width: 100%;">
            <table class="table p-0 m-0">
                <thead>
                    <tr style="writing-mode: sideways-lr;">
                        <th class="bg-light fixed-column" style="width: 100%;"></th>
                        <th class="bg-light" *ngFor="let skill of skills">
                            <div class="d-flex justify-content-center">
                                <div class="vertical-text text-nowrap text-truncate" style="max-height: 200px;"
                                    [tooltip]="skill.skillName">
                                    {{skill.skillName}}
                                </div>
                            </div>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let participantSkills of participantsSkills">
                        <td class="text-nowrap bg-light fixed-column col-fixed-140">
                            <div>
                                <div 
                                class="d-flex flex-column w-100 lh-sm"
                                [tooltip]="personNameService.getFullName(participantSkills.personFirstName, participantSkills.personLastName)"
                                [placement]="'top start'"
                                >
                                    <div class="w-100 overflow-hidden">
                                        <span class="d-block text-nowrap text-truncate">
                                         {{ participantSkills.personFirstName }}
                                        </span>
                                    </div>
                                    <div class="w-100 overflow-hidden">
                                        <span class="d-flex justify-content-between align-items-center w-100">
                                            <span class="text-nowrap text-truncate me-1">
                                                {{ participantSkills.personLastName }}
                                            </span>
                                            <span class="text-nowrap flex-shrink-0">
                                                {{ participantSkills.attendanceCount }}/{{ participantSkills.eventLessonCount }}
                                            </span>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </td>
                        <td *ngFor="let participantSkill of participantSkills.skills" class="p-2 bg-light">

                            <button class="btn border-0 bg-success text-light text-center"
                                *ngIf="isSelectedAndNew(participantSkill)"
                                (click)="changeState($event, participantSkills, participantSkill, assignmentParticipantSkillStateEnum.Lacking)">
                                <i class="fa-solid fa-circle-plus fa-xs"></i>
                            </button>

                            <button class="btn border-0 bg-success text-light text-center"
                                *ngIf="isSelectedAndExisting(participantSkill)"
                                (click)="changeState($event, participantSkills, participantSkill, assignmentParticipantSkillStateEnum.Extending)">
                                <i class="fa-solid fa-circle-check fa-xs"></i>
                            </button>

                            <button class="btn border-0 bg-secondary text-light text-center"
                                *ngIf="isLackingAndNotExisting(participantSkill)"
                                (click)="changeState($event, participantSkills, participantSkill, assignmentParticipantSkillStateEnum.InPossession)">
                                <i class="fa-solid fa-circle fa-xs"></i>
                            </button>
                            <button class="btn border-0 bg-danger text-light text-center"
                                *ngIf="isLackingAndExisting(participantSkill)"
                                (click)="changeState($event, participantSkills, participantSkill, assignmentParticipantSkillStateEnum.InPossession)">
                                <i class="fa-solid fa-circle-xmark fa-xs"></i>
                            </button>
                            <button class="btn border-0 bg-primary text-light text-center"
                                *ngIf="isExtendingdExisting(participantSkill)"
                                (click)="changeState($event, participantSkills, participantSkill, assignmentParticipantSkillStateEnum.Lacking)">
                                <i class="fa-solid fa-solid fa-circle-arrow-right fa-xs"></i>
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="d-flex flex-row gap-2 flex-wrap mt-3">
            <div class="badge badge-secondary">
                <i class="fa-solid fa-circle-check text-success"></i>
                {{'assignments.participants.skills.existing' | transloco}}
            </div>
            <div class="badge badge-secondary">
                <i class="fa-solid fa-circle-plus text-success"></i>
                {{'assignments.participants.skills.new' | transloco}}
            </div>
            <div class="badge badge-secondary">
                <i class="fa-solid fa-solid fa-circle-arrow-right text-primary"></i>
                {{'assignments.participants.skills.extend' | transloco}}
            </div>
            <div class="badge badge-secondary">
                <i class="fa-solid fa-circle-xmark text-danger"></i>
                {{'assignments.participants.skills.remove' | transloco}}
            </div>
        </div>
    </ng-container>
    <ng-container *ngIf="participantsSkills && isConfirming">
        <div class="d-flex flex-column gap-2">
            <ng-container *ngIf="isAnySkillUpdated()">
                <div class="alert alert-secondary">
                    {{'assignments.participants.skills.changed' | transloco}}
                </div>
                <div *ngFor="let skillsUpdate of getSortedSkillsUpdates(skillsUpdates)">
                    <ng-container
                        *ngIf="skillsUpdate.addedSkills.length || skillsUpdate.removedSkills.length || skillsUpdate.extendingSkills.length">
                        <p><b>{{skillsUpdate.personFirstName}} {{skillsUpdate.personLastName}}</b></p>
                        <ng-container *ngFor="let addedSkill of getSortedSkills(skillsUpdate.addedSkills)">
                            <p><span class="badge bg-success"><i class="fa-solid fa-circle-plus small"></i></span>
                                {{addedSkill.skillName}}
                            </p>
                        </ng-container>
                        <ng-container *ngFor="let extendingSkills of getSortedSkills(skillsUpdate.extendingSkills)">
                            <p><span class="badge bg-primary"><i class="fa-solid fa-circle-arrow-right small"></i></span>
                                {{extendingSkills.skillName}}
                            </p>
                        </ng-container>
                        <ng-container *ngFor="let removedSkill of getSortedSkills(skillsUpdate.removedSkills)">
                            <p><span class="badge bg-danger"><i class="fa-solid fa-circle-minus small"></i></span>
                                {{removedSkill.skillName}}
                            </p>
                        </ng-container>
                    </ng-container>
                </div>
            </ng-container>
            <ng-container *ngIf="!isAnySkillUpdated()">
                <div class="alert alert-secondary">
                    {{'assignments.participants.skills.noneChanged' | transloco}}
                </div>
            </ng-container>
            <hr class="pb-0 mb-0">
            <div>
                <button class="btn btn-light" (click)="back()">{{'modal.backButton' | transloco}}</button>
            </div>
        </div>
    </ng-container>
</pmt-action-modal>